import React, { Component } from 'react'
import TaskStatus from '../task/task-status'
import TaskPeople from '../task/task-people'
import Icon from 'components/icon/icon'

import TaskDates from '../task/task-dates'
import TaskText from '../task/task-text'

import TimeAgo from 'react-timeago'

import {
	getColumns,
	getHeadingLabels,
	formatByTimeZone
} from 'utils'

import ProfilePicture from 'components/profile/profile-picture'

export default class SingleTaskInfo extends Component {
	state = {
		renderColumns: true
	}

	hasFeature = _ => {

	}

	UNSAFE_componentWillUpdate(nextProps, nextState) {
		const { applicableUsers } = this.props
		const nextApplicableUsers = nextProps.applicableUsers

		let hasUnequalIds = false

		applicableUsers && applicableUsers.some((user, index) => {
			if(user.id && nextApplicableUsers[index] && nextApplicableUsers[index].id && user.id !== nextApplicableUsers[index].id){
				hasUnequalIds = true
				return true
			}
		})

		if(hasUnequalIds){
			this.setState({
				renderColumns: false
			}, _ => {
				setTimeout(_ => {
					this.setState({
						renderColumns: true
					})
				})
			})
		}
	}

	render() {
		const {
			currentProject,
			isArchived,
			taskObject,
			menuState,
			applicableUsers,
			openMenu,
			allUsers,
			hasGantts,
			isProjectEditable,
			isPremium
		} = this.props

		const {
			renderColumns
		} = this.state

		let className = 'creator-container'

		let creator = null

		if(taskObject.created_by){
			creator = allUsers[taskObject.created_by]
		}

		const currentOpenColumnId = menuState.currentOpenColumnId ? menuState.currentOpenColumnId.toString() : ''

		const columns = getColumns(currentProject, isPremium, true)
		const labels = getHeadingLabels(columns, this.hasFeature)

		console.log('menu state:')
		console.log('this wont respond to click on occasion:')
		console.log(menuState)

		const createdMoment = formatByTimeZone(taskObject.created_at, null, true)
		const today = formatByTimeZone(null, null, true)
		const yesterday = today.clone().subtract(1, 'day')

		const createdString = (() => {
			let _response = `Created `

			if(createdMoment.isSame(today, 'day')){
				_response += 'today'
			}else if(createdMoment.isSame(yesterday, 'day')){
				_response += 'yesterday'
			}else {
				const isCurrentYear = createdMoment.year() === today.year()
				_response += createdMoment.format(isCurrentYear ? 'Do MMMM' : 'Do MMMM YYYY')
			}

			_response += ` at ${ createdMoment.format('h:mm a') } by:`

			return _response
		})()

		return (
			<div>
				{ creator &&
					<div className={className}>
						<label>
							{ createdString }
						</label>
						<div>
							<ProfilePicture user={creator} isTiny={true} />
							<div className="user-title">
								<label>
									{ creator.first_name+' '+creator.last_name }
								</label>
								<span className="disclaimer">
									{ (creator.role && creator.role != 'null') ? creator.role : 'Guest' }
								</span>
							</div>
						</div>
					</div>
				}
				{ renderColumns && columns.map((column, index) => {
					let slug = column.type.toLowerCase()
					let label = null
					let component = null
					let className = ''
					
					const key = column.type+'_'+column.id

					const commonProps = {
						key,
						disabled: !isProjectEditable,
						task: taskObject,
						openMenu,
						menuState,
						column,
						currentProject,
						hasGantts,
						isSingle: true
					}

					label = labels[index].title

					const isOpen = menuState.currentOpenColumnId && menuState.currentOpenColumnId === column.id

					switch(column.type){
						case 'STATUS':
							if(isOpen){
								className += ' open'
							}

							component = (
								<TaskStatus
									{...commonProps}
								/>
							)
							break
						case 'PEOPLE':
							component = (
								<TaskPeople
									applicableUsers={applicableUsers}
									{...commonProps}
								/>
							)
							break
						case 'DATE':
							if(hasGantts){
								label = 'Dates'
							}

							component = (
								<TaskDates
									{...commonProps}
								/>
							)

							slug = 'dates'

							if(currentOpenColumnId.includes(''+column.id) && (currentOpenColumnId.includes('start') || currentOpenColumnId.includes('end'))){
								className += ' open'
							}
							break
						case 'TEXT':
						case 'LINK':
							component = (
								<TaskText
									{...commonProps}
								/>
							)
							break
					}

					className += ' '+slug+"-container widget"

					return (
						<React.Fragment key={key}>
							<label>
								{ label }
							</label>
							<div className={className} onClick={e => { e.stopPropagation() }}>
								{ component }
								{ (slug == 'status' && !isArchived) &&
									<div className="carets">
										<Icon name="caret-down" />
									</div>
								}
								{(!isArchived && isProjectEditable && slug == 'dates') ?
									<div className="carets">
										{ hasGantts ?
											<Icon name="caret-down" />
										: null }
										<Icon name="caret-down" />
									</div>
									: null
								}
								</div>
						</React.Fragment>
					)
				})}
			</div>
		)
	}
}

